/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rankings_Cat_LimitedInputs */



/**
* | output |
* | --- |
* | "Limited" |
*
* @param {Rankings_Cat_LimitedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rankings_cat_limited = /** @type {((inputs?: Rankings_Cat_LimitedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rankings_Cat_LimitedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Limité")
	if (locale === "es") return /** @type {LocalizedString} */ ("Limited")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Limited")
	if (locale === "it") return /** @type {LocalizedString} */ ("Limited")
	return /** @type {LocalizedString} */ ("Limited")
});